/**
 * Knowledge Hub Background Switching
 * Handles background image switching on hover
 */

document.addEventListener("DOMContentLoaded", function () {
  const knowledge_hub = document.querySelector(".knowledge-hub");
  const links = document.querySelectorAll(".knowledge-hub__link[data-bg-desktop], .knowledge-hub__link[data-bg-mobile]");

  if (!knowledge_hub || !links.length) return;

  let currentActiveBg = null;
  let fadingBg = null;

  function isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  // Check if hover is supported and screen is above 1280px
  function canHover() {
    return (
      window.matchMedia("(hover: hover)").matches && isDesktop()
    );
  }

  // Get the appropriate background URL based on viewport
  function getBgUrl(element, prefix = "data-bg") {
    const desktop = element.getAttribute(`${prefix}-desktop`);
    const mobile = element.getAttribute(`${prefix}-mobile`);
    return isDesktop() ? (desktop || mobile) : (mobile || desktop);
  }

  // Function to create a background element
  function createBgElement(imageUrl, opacity = "0") {
    const newBG = document.createElement("div");
    newBG.className =
      "knowledge-hub__bg absolute inset-0 bg-cover bg-center transition-opacity duration-500 ease-in-out";
    newBG.style.cssText = `background-image: url('${imageUrl}'); opacity: ${opacity}; z-index: ${
      fadingBg ? "2" : "1"
    };`;
    return newBG;
  }

  // Function to switch to background image with smooth transition (only on hover devices)
  function switchToBackground(imageUrl) {
    // Only run on hover devices above 1280px
    if (!canHover()) return;
    // Don't switch if it's the same background
    if (currentActiveBg === imageUrl) return;

    const newBG = createBgElement(imageUrl);
    knowledge_hub.appendChild(newBG);

    // Fade in new background
    setTimeout(() => {
      newBG.style.opacity = "1";
    }, 10);

    setTimeout(() => {
      if (fadingBg) {
        fadingBg.remove();
      }
      fadingBg = newBG;
      currentActiveBg = imageUrl;
      newBG.style.zIndex = "1";
    }, 500);
  }

  // Function to set default background from first link's data attributes
  function setDefaultBackground() {
    // Get first link with default background data
    const firstLink = knowledge_hub.querySelector(
      ".knowledge-hub__link[data-default-desktop], .knowledge-hub__link[data-default-mobile]"
    );

    if (firstLink) {
      const defaultBgUrl = getBgUrl(firstLink, "data-default");

      if (defaultBgUrl) {
        const defaultBG = createBgElement(defaultBgUrl, "1");
        knowledge_hub.insertAdjacentElement("afterbegin", defaultBG);
        fadingBg = defaultBG;
        currentActiveBg = defaultBgUrl;
      }
    }
  }

  setDefaultBackground();

  // Function to remove active class from all links
  function removeActiveClasses() {
    links.forEach(function (link) {
      link.classList.remove("text-yellow");
    });
  }

  // Add event listeners to links
  links.forEach(function (link) {
    link.addEventListener("mouseenter", function (e) {
      e.preventDefault();
      const bg_image = getBgUrl(this, "data-bg");

      removeActiveClasses();

      this.classList.add("text-yellow");

      if (bg_image) {
        switchToBackground(bg_image);
      }
    });
  });
});
